import * as React from 'react';
import { sendUXSEvent } from 'shared/utils/uxs';

import {
  getLocalStorageFiltersIsExpired,
  getLocalStorageFiltersPollWasShow,
  getLocalStorageFiltersWereApplied,
  getLocalStorageFiltersWereAppliedTwoTimes,
  removeLocalStorageFiltersWereApplied,
  setLocalStorageFiltersPollWasShow,
} from './localStorageUtils';

export function useFiltersUxfbPoll() {
  const existing = getLocalStorageFiltersWereApplied();
  const isExpired = getLocalStorageFiltersIsExpired(existing);
  const wereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(existing);
  const isShown = getLocalStorageFiltersPollWasShow(existing);

  React.useEffect(() => {
    //Удаляем значение из LS через 7 дней
    if (isExpired) {
      removeLocalStorageFiltersWereApplied();

      return;
    }

    let timeoutId: NodeJS.Timeout;

    if (wereAppliedTwoTimes && !isShown) {
      timeoutId = setTimeout(() => {
        sendUXSEvent('AudMonFilterDesktop');
        setLocalStorageFiltersPollWasShow(existing);
      }, 3000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isExpired, wereAppliedTwoTimes, isShown]);
}
